export const REPORT_TYPES = {
  ALL: {
    label: "All",
    value: "ALL"
  },
  PERSONALIZATION: {
    label: "Personalized",
    value: "PERSONALIZATION"
  },
  ABM:  {  
    label: "Campaign",
    value: "ABM"
  }
}

export const defaultReportType = REPORT_TYPES.ALL.value

export const REPORT_SUMMARY_LEFT = {
  ALL: [
    {
      path: '/images/reports/sessions.svg',
      title: 'Sessions',
      description: 'Recorded',
      accessorKey: "sessions"
    },
    {
      path: '/images/reports/visitors.svg',
      title: 'Visitors',
      description: 'Attracted',
      accessorKey: "visitors"
    },
    {
      path: '/images/reports/leads.svg',
      title: 'Leads',
      description: 'Captured',
      accessorKey: "leads"
    }
  ],
  PERSONALIZATION: [
    {
      path: '/images/reports/leads.svg',
      title: 'Personalised Lead',
      description: 'Count',
      accessorKey: "leads"
    },
    {
      path: '/images/reports/sessions.svg',
      title: 'Personalised views',
      description: 'Opened',
      accessorKey: "views"
    },
    {
      path: '/images/reports/visitors.svg',
      title: 'Bounce Rate',
      description: 'percentage',
      accessorKey: "bounceRate"
    },
  ],
  ABM: [
     {
      path: '/images/reports/sessions.svg',
      title: 'Views',
      description: 'Number of views',
      accessorKey: "views"
    },
    {
      path: '/images/reports/visitors.svg',
      title: 'Visitors',
      description: 'Total number',
      accessorKey: "visitors"
    },
    {
      path: '/images/reports/leads.svg',
      title: 'Lead Count',
      description: 'Leads captured',
      accessorKey: "leads"
    },
  ]
}
